
import { hydrateCSRTemplate } from "@fiverr-private/layout_lib/CSRTemplate";

import UserActivationMessage from '/home/circleci/app/packages/layout-user-activation-message-component/src/entries/UserActivation';

const element = typeof document !== 'undefined' && document.querySelector('#UserActivationMessage');
if (element) {
    const props = window.initialData['UserActivationMessage'];

    hydrateCSRTemplate(UserActivationMessage, props, element, 'UserActivationMessage', 'UserActivation');
}
export default UserActivationMessage;
